import useLocale from "@/vue/composables/useLocale";

const getSiteFromDomain = (domain: string) => {
	// For local development or preprod QA, we use the language as the domain
	if (domain === 'localhost' || domain === 'migdal.travelfactory.fr') {
		return "www.uk.travelski.com";
			// "en_US": "www.uk.travelski.com",
			// "fr_FR": "www.travelski.com",
			// "fr_FR": "www.befr.yoonly.eu",
			// "nl_NL": "www.nl.travelski.com",
			// "nl_NL": "www.nl.yoonly.eu",
			// "fr_FR_CSE": "cse.travelski.com"
	}

	switch (domain) {
		case "www.nl.travelski.com":
		case "da46ut62inok9.cloudfront.net":
		case "nl.travelski.com": {
			return 'www.nl.travelski.com';
		}
		case "www.uk.travelski.com":
		case "preprod2.travelski.com":
		case "d1pmfz5968qaqq.cloudfront.net":
		case "uk.travelski.com": {
			return 'www.uk.travelski.com';
		}
		case "cse.travelski.com":
		case "d3seofksg16p6m.cloudfront.net": {
			return 'cse.travelski.com';
		}
		case "d2ih3lf8k24h8o.cloudfront.net": 
		case "www.befr.yoonly.eu": {
			return 'www.befr.yoonly.eu';
		}
		case "www.benl.yoonly.eu": {
			return 'www.benl.yoonly.eu';
		}
		case "www.nl.yoonly.eu": {
			return 'www.nl.yoonly.eu';
		}
		case "www.travelski.com": 
		case "d2qeb9hl0mi6k3.cloudfront.net":
		case "preprod1.travelski.com": 
		default: {
			return 'www.travelski.com';
		}
	}
};

export default getSiteFromDomain;
